import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscord = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.78,
	height: 10.5,
	viewBox: "0 0 13.78 10.5",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M13.72,8.73s0,.02-.02,.03c-1.04,.77-2.21,1.36-3.45,1.74-.02,0-.04,0-.05-.02-.26-.36-.5-.75-.7-1.14-.01-.02,0-.05,.02-.06,.37-.14,.73-.31,1.08-.51,.03-.02,.03-.05,0-.07-.07-.05-.15-.11-.21-.17-.01-.01-.03-.01-.04,0-2.23,1.03-4.67,1.03-6.93,0-.02,0-.03,0-.04,0-.07,.06-.14,.11-.21,.17-.02,.02-.02,.06,0,.07,.34,.2,.7,.37,1.08,.51,.02,0,.04,.04,.02,.06-.2,.4-.44,.78-.7,1.15-.01,.01-.03,.02-.05,.02-1.24-.38-2.4-.97-3.44-1.74,0,0-.02-.02-.02-.03C-.18,6.16,.31,3.55,2.09,.89c0,0,.01-.01,.02-.02C3,.46,3.95,.17,4.92,0c.02,0,.04,0,.04,.02,.13,.23,.25,.47,.35,.72,1.04-.16,2.11-.16,3.15,0,.1-.24,.22-.48,.35-.72,0-.02,.03-.02,.04-.02,.97,.17,1.91,.46,2.81,.87,0,0,.01,0,.02,.02,1.56,2.29,2.32,4.87,2.04,7.84Zm-7.88-2.95c.01-.76-.54-1.39-1.24-1.39s-1.24,.62-1.24,1.39,.56,1.39,1.24,1.39,1.24-.62,1.24-1.39Zm4.58,0c.01-.76-.54-1.39-1.24-1.39s-1.24,.62-1.24,1.39,.56,1.39,1.24,1.39,1.24-.62,1.24-1.39Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgDiscord);
export default ForwardRef;
